import { render } from "./companyStatistics.vue?vue&type=template&id=bed247de&scoped=true"
import script from "./companyStatistics.vue?vue&type=script&lang=js"
export * from "./companyStatistics.vue?vue&type=script&lang=js"

import "./companyStatistics.vue?vue&type=style&index=0&id=bed247de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bed247de"

export default script